import React ,{useState, useEffect} from 'react';
import Link from 'next/link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import darkTheme from '../../src/theme';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NavBarContainer = {
    position:'fixed', 
    top:0, 
    left:0, 
    width:'100%',
    display:'flex',
    zIndex:999, 
    background:darkTheme.palette.background.tickets,
    px:2,
    pt:1,
    alignItems:'center',
    borderBottom:`1px solid ${darkTheme.palette.background.ticket}`,
    '& h3':{
        fontSize: 18,
        fontWeight:100,
        textTransform:'capitalize',
        color: darkTheme.palette.primary.title
    }
}


const CustomNavbar = (props) => {    
    const [show, setShow] = useState(false);
    useEffect(() => {
        let previousScrollPosition = 0;
        let currentScrollPosition = 0;
        window.addEventListener('scroll', function (e) {
        currentScrollPosition = window.pageYOffset;
        if (previousScrollPosition - currentScrollPosition <= 0) {
            setShow(true);
        } else if (previousScrollPosition - currentScrollPosition >= 0) {
            setShow(true);
        }
        previousScrollPosition = currentScrollPosition;
        });
    }, []);

    const EVENT_TITLE_MAX_LENGTH = 35;
    
    return (
        <Stack flexDirection="row" sx={NavBarContainer} className={`${show ? 'visible' : 'hidden'}`}>
            <Link href={props.city == '' ? `/${props.url}` : "/" + props.city + `/${props.url}`} as={props.city == '' ? "/" : "/" + props.city + `/${props.url}`} sx={{ flexGrow: '2' }}>
                <a style={{ 'padding': '8px 0', 'display':'block', color: darkTheme.palette.common.white }}>
                    <ArrowBackIcon />
                </a>
            </Link>
            <Typography
                variant="h3"
                sx={{ textTransform: "capitalize !important" , ml:2}}
                >
                {(props.title.length >= EVENT_TITLE_MAX_LENGTH
                    ? (props.title.toLowerCase()).substring(0, EVENT_TITLE_MAX_LENGTH) +
                    "..."
                    : props.title.toLowerCase()
                ).toLowerCase()}
                </Typography>  
        </Stack>
        

    )}
export default CustomNavbar;
